import React, { useState } from 'react';
import { Stethoscope, ChevronLeft, ChevronRight } from 'lucide-react';
import { Building2, GraduationCap } from 'lucide-react';
import IMATStudentList from './IMATStudentList';

const IMATPage: React.FC = () => {
    const [selectedProgram, setSelectedProgram] = useState<string>('imat');
    const [isCollapsed, setIsCollapsed] = useState(false);

    const universities = [
        { id: 'imat', label: 'Tüm IMAT', icon: GraduationCap },
        { id: 'sapienza', label: 'La Sapienza', icon: Building2 },
        { id: 'milano-statale', label: 'Milano Statale', icon: Building2 },
        { id: 'pavia', label: 'Pavia', icon: Building2 },
        { id: 'bologna', label: 'Bologna', icon: Building2 },
        { id: 'padova', label: 'Padova', icon: Building2 },
        { id: 'tor-vergata', label: 'Tor Vergata', icon: Building2 },
        { id: 'turin', label: 'Turin', icon: Building2 },
        { id: 'bicocca', label: 'Bicocca', icon: Building2 },
        { id: 'federico', label: 'Federico II', icon: Building2 },
        { id: 'parma', label: 'Parma', icon: Building2 },
        { id: 'messina', label: 'Messina', icon: Building2 },
        { id: 'vanvitelli', label: 'Luigi Vanvitelli', icon: Building2 },
        { id: 'bari', label: 'Bari', icon: Building2 },
        { id: 'catania', label: 'Catania', icon: Building2 },
        { id: 'marche', label: 'Marche (Ancona)', icon: Building2 },
        { id: 'cagliari', label: 'Cagliari', icon: Building2 },
        { id: 'siena-dentistry', label: 'Siena (Diş)', icon: Stethoscope },
        { id: 'sapienza-dentistry', label: 'La Sapienza (Diş)', icon: Stethoscope },
        { id: 'bologna-vetmed', label: 'Bologna (Vet)', icon: Stethoscope },
    ];

    return (
        <div className="flex h-[calc(100vh-theme(spacing.16))]">
            {/* Internal Sidebar */}
            <div className={`${isCollapsed ? 'w-20' : 'w-64'} bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 overflow-y-auto transition-all duration-300 flex flex-col`}>
                <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between sticky top-0 bg-white dark:bg-gray-800 z-10">
                    {!isCollapsed && <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 whitespace-nowrap overflow-hidden">IMAT Üni.</h2>}
                    <button
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        className={`p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 transition-colors ${isCollapsed ? 'mx-auto' : ''}`}
                    >
                        {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
                    </button>
                </div>
                <nav className="p-2 space-y-1">
                    {universities.map((uni) => {
                        const Icon = uni.icon;
                        return (
                            <button
                                key={uni.id}
                                onClick={() => setSelectedProgram(uni.id)}
                                title={isCollapsed ? uni.label : undefined}
                                className={`w-full flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-3 py-2 rounded-lg text-sm font-medium transition-colors ${selectedProgram === uni.id
                                    ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400'
                                    : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                                    }`}
                            >
                                <Icon size={20} className="shrink-0" />
                                {!isCollapsed && <span className="truncate">{uni.label}</span>}
                            </button>
                        );
                    })}
                </nav>
            </div>

            {/* Content Area */}
            <div className="flex-1 overflow-auto bg-gray-50 dark:bg-gray-900 p-6">
                <IMATStudentList
                    programType={selectedProgram}
                    universityList={universities.filter(u => u.id !== 'imat').map(u => u.label)}
                />
            </div>
        </div>
    );
};

export default IMATPage;
